import { render, staticRenderFns } from "./CityHospitalCluster.vue?vue&type=template&id=2c2591c8&"
import script from "./CityHospitalCluster.vue?vue&type=script&lang=js&"
export * from "./CityHospitalCluster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports